import styled from "styled-components";

export const ButtonModal = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  button {
    background: none;

    svg:hover {
      transform: scale(1.2);
      cursor: pointer;
    }
  }
`;
